import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 24px;
  height: 24px;
  color: #000000;
`

const ArrowUp = ({ title = 'Add', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 24 24" title={title} {...rest}>
    <rect data-element="frame" width={24} height={24} rx={1} ry={1} fill="none" />
    <g
      className="prefix__nc-icon-wrapper"
      strokeLinecap="square"
      strokeWidth={2}
      stroke="currentColor"
      fill="none"
      strokeMiterlimit={10}
    >
      <path data-cap="butt" data-color="color-2" strokeLinecap="butt" d="M12 18V6" strokeWidth={1.2} />
      <path d="M7.8 10.2L12 6l4.2 4.2" strokeWidth={1.2} />
    </g>
  </StyledIcon>
)

ArrowUp.displayName = 'ArrowUp'
ArrowUp.needsWork = true
export default ArrowUp
